export function groupBy (data, key) {
  return data.reduce(function(y, x) {
    (y[x[key]] = y[x[key]] || []).push(x);
    return y;
  }, {});
};

export function selectEntry(entries, value) {
  let selected = entries.slice()
  const index = entries.findIndex(entry => entry === value)

  if (index === -1) {
    selected.push(value)
  } else {
    selected.splice(index, 1)
  }

  return selected
}



// WEBPACK FOOTER //
// ./src/store/utils/helpers.js